export const LINKS = {
    DEMO_VIDEO_MP4: 'https://d33jnybhrjl9rg.cloudfront.net/mwm-videos/meDzhub-video.mp4',
    PLAY_STORE_APP: 'https://play.google.com/store/apps/details?id=com.meDZhub',
    APP_STORE_APP: 'https://apps.apple.com/us/app/medzhub/id6755685306',
};

